import { Injectable, inject } from '@angular/core';
import { where } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Attachment } from '../models/attachment.model';
import { IService } from '../models/service.interface';
import { Roles } from '../utility/role';
import { FirestoreService } from './firestore.service';

const itemCollection = 'attachments';

@Injectable({
  providedIn: 'root',
})
export class AttachmentsService implements IService<Attachment> {
  private firestore = inject(FirestoreService);

  async save(item: Attachment) {
    return this.firestore.save(itemCollection, item);
  }

  async update(item: Attachment) {
    return this.firestore.update(itemCollection, item);
  }

  async remove(item: Attachment) {
    return this.firestore.delete(itemCollection, item);
  }

  get(guid: string): Observable<Attachment> {
    return this.firestore.get<Attachment>(itemCollection, guid);
  }

  getList(options?: { site: string; contractor?: string; role?: Roles; project?: string | null }): Observable<Attachment[]> {
    const queryConstraints = [];
    if (options?.site) {
      queryConstraints.push(where('site', '==', options.site));
    }
    if (options?.project) {
      queryConstraints.push(where('project', '==', options.project));
    }
    if (options?.contractor) {
      queryConstraints.push(where('contractors', 'array-contains', options.contractor));
    } else {
      queryConstraints.push(where('showToClient', '==', true));
    }
    if (options?.role) {
      queryConstraints.push(where('showToWorker', '==', true));
    }

    return this.firestore
      .getList<Attachment>(itemCollection, undefined, queryConstraints);
  }
}
